import React from "react";
import { AwardsItemProps } from "../AwardsItem/AwardsItem";
import AwardsList from "../AwardsList";
import Container from "../Container";
import { animated, config, useTrail } from "react-spring";

export interface AwardsGroupProps {
  title: string;
  subtitle: string;
  awards: AwardsItemProps[];
}

const AwardsGroup = ({ title, subtitle, awards }: AwardsGroupProps) => {
  // Animations
  const fadeInUpTrail = useTrail(3, {
    config: config.slow,
    opacity: 1,
    transform: "translateY(0px)",
    from: {
      opacity: 0,
      transform: "translateY(10px)",
    },
  });

  return (
    <Container>
      <div className="py-12 text-center">
        <animated.div
          className="max-w-md mx-auto my-4 text-5xl font-bold leading-none"
          style={fadeInUpTrail[1]}
        >
          {title}
        </animated.div>
        <animated.div
          className="my-4 text-sm text-gray-400"
          style={fadeInUpTrail[2]}
        >
          {subtitle}
        </animated.div>
      </div>

      <AwardsList awards={awards} />
    </Container>
  );
};

export default AwardsGroup;
